import { render, staticRenderFns } from "./EvaluationModal.vue?vue&type=template&id=389fd079&scoped=true"
import script from "./EvaluationModal.vue?vue&type=script&lang=js"
export * from "./EvaluationModal.vue?vue&type=script&lang=js"
import style0 from "./EvaluationModal.vue?vue&type=style&index=0&id=389fd079&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389fd079",
  null
  
)

export default component.exports